import { Line } from '@react-three/drei'
import type { PontoBaixo } from '../../dominio/cenario/predios'
import { Rotulo3D } from '../componentes/Rotulo3D'

const nenhumRaio = () => null

/**
 * Bueiros e córrego. Com gás denso, ganham destaque e rótulo: é onde a nuvem
 * se acumula e por onde ela "anda" para longe do eixo da pluma.
 */
export function PontosBaixos3D({ pontos, destacar }: { pontos: readonly PontoBaixo[]; destacar: boolean }) {
  return (
    <group>
      {pontos.map((ponto, indice) =>
        ponto.tipo === 'bueiro' ? (
          <group key={ponto.id} position={[ponto.pontos[0]![0], 0, ponto.pontos[0]![1]]}>
            <mesh position={[0, 0.03, 0]} raycast={nenhumRaio}>
              <boxGeometry args={[0.9, 0.04, 0.9]} />
              <meshStandardMaterial color={destacar ? '#a855f7' : '#15181c'} emissive={destacar ? '#a855f7' : '#000000'} emissiveIntensity={destacar ? 0.6 : 0} />
            </mesh>
            {/* um rótulo basta para todos os bueiros; vários empilhariam junto à fonte */}
            {destacar && indice === pontos.findIndex((p) => p.tipo === 'bueiro') && (
              <Rotulo3D posicao={[0, 2.5, 0]} texto="Bueiros" subtexto="gás denso entra na galeria" variante="eixo" fator={30} />
            )}
          </group>
        ) : (
          <group key={ponto.id}>
            <Line
              points={ponto.pontos.map(([x, z]) => [x, 0.05, z] as [number, number, number])}
              color={destacar ? '#a855f7' : '#3b82f6'}
              lineWidth={destacar ? 6 : 4}
              raycast={nenhumRaio}
            />
            {destacar && (
              <Rotulo3D
                posicao={[ponto.pontos[2]![0], 4, ponto.pontos[2]![1]]}
                texto="Córrego (baixada)"
                subtexto="gás denso escoa pelo leito"
                variante="eixo"
                fator={80}
              />
            )}
          </group>
        ),
      )}
    </group>
  )
}
